import { EnviromentZone, HowdenLoginBehaviour, HowdenLoginKind, IHowdenEnvironment, LogLevel, TENANT_TYPES } from '@howdeniberia/core-front';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT,
  appIdSecurity: 16, //Es necesario establecer el Id de la aplicación asignado en Howden Security
  relatedIdsSecurity: [17], //Id Intranet Singular
  loginBehaviour: HowdenLoginBehaviour.REDIRECT,
  loginKind: HowdenLoginKind.INTERNAL,
  howdenLoginUrl: 'https://how-login.app-dev.howdeniberia.com',
  externalAppTitle: 'ARPA',
  fixedTenant: TENANT_TYPES.singular,
  logLevel: LogLevel.INFO,
  logoDestination: ''
} as IHowdenEnvironment;
